// extracted by mini-css-extract-plugin
export default {"PurchasePartiesPage":"PurchasePartiesPage_PurchasePartiesPage__kPnvZ"};